// extracted by mini-css-extract-plugin
export default {"container":"mainComing_container__y97LN"};